import * as React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslations } from '../../store/translations/hooks';
import { TK } from '../../store/translations/translationKeys';
import { getGeneralSettings } from '../../store/settings/selectors';
import { updateGeneralSettings } from '../../store/settings/actions';
import { GeneralSettingsData } from '../../models';
import ClientProfileSettings from '../Settings/ClientProfileSettings';
import AppButton from '../../components/AppButton';

interface ClientProfileSettingsModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const ClientProfileSettingsModal: React.FC<ClientProfileSettingsModalProps> = ({ isOpen, onClose }) => {
    const t = useTranslations();
    const dispatch = useDispatch();
    const generalSettings = useSelector(getGeneralSettings);
    const [draft, setDraft] = React.useState<GeneralSettingsData>(generalSettings);

    React.useEffect(() => {
        if (isOpen) setDraft(generalSettings);
    }, [isOpen]);

    const handleSave = () => {
        dispatch(updateGeneralSettings(draft));
        onClose();
    };

    return (
        <Modal isOpen={isOpen} toggle={onClose} size="xl">
            <ModalHeader toggle={onClose}>{t(TK.clientProfileSettings)}</ModalHeader>
            <ModalBody>
                <ClientProfileSettings id="client-profile" values={draft} onChange={setDraft} />
            </ModalBody>
            <ModalFooter>
                <AppButton color="secondary" onClick={onClose}>{t(TK.cancel)}</AppButton>
                <AppButton color="success" onClick={handleSave}>{t(TK.save)}</AppButton>
            </ModalFooter>
        </Modal>
    );
};

export default ClientProfileSettingsModal;
